import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';
import EmptyIconWithText from 'components/Widgets/EmptyIconWithText';

export default function Index({
  avatar, bigIcon, iconClassName, contentClassName, wrapperClassName, children,
}) {
  const size = bigIcon ? '64px' : '40px';

  if (avatar === null) {
    return (
      <EmptyIconWithText
        size={size}
        contentClassName={contentClassName}
        wrapperClassName={wrapperClassName}
      >
        <div className="mb-1 small fw-light text-gray-700">Coach</div>

        <div className="fw-semibold">
          -
        </div>
      </EmptyIconWithText>
    );
  }

  const content = children || (
    <>
      <div className="mb-1 small fw-light text-gray-700">Coach</div>

      <div className="fw-semibold text-gray-900">
        {avatar.name}
      </div>
    </>
  );

  const icon = (
    <>
      {avatar.avatar_url ? (
        <IconWithText
          iconClassName={`picture-icon ${bigIcon ? 'big-icon' : ''} rounded-circle ${iconClassName}`}
          iconStyle={{ backgroundImage: `url(${avatar.avatar_url})` }}
          contentClassName={contentClassName}
          wrapperClassName={wrapperClassName}
        >
          {content}
        </IconWithText>
      ) : (
        <EmptyIconWithText
          size={size}
          contentClassName={contentClassName}
          wrapperClassName={wrapperClassName}
        >
          {content}
        </EmptyIconWithText>
      )}
    </>
  );

  return (
    <>
      {icon}
    </>
  );
}

Index.propTypes = {
  avatar: PropTypes.object,
  bigIcon: PropTypes.bool,
  iconClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  children: PropTypes.node,
};

Index.defaultProps = {
  avatar: null,
  bigIcon: true,
  iconClassName: '',
  contentClassName: '',
  wrapperClassName: '',
  children: null,
};
